import React, { useState } from 'react'
import Map from '../../Shared/Map/Map'
import SingleDest from '../SingleDest/SingleDest'
import BookingModal from './BookingModal'

const CoxHotels = ({name, hotels}) => {
    const [hotelName, setHotelName] = useState('')

    return (
        <>
            <div className="grid grid-cols-2 gap-10 px-16 py-6">
                <div className="grid grid-cols-1 gap-5">
                    {
                        hotels.map(hotel => 
                            <SingleDest hotel={hotel} setHotelName={setHotelName}/>)
                    }
                </div>
                <div>
                    <Map position={[21.42421767683566, 91.97971921966322]} name={name}/>
                </div>
            </div>
            {hotelName && <BookingModal hotelName={hotelName} setHotelName={setHotelName}/>}
        </>
    );
};

export default CoxHotels;